import { Component, h } from 'preact'
import axios from 'axios'
import EventCalendarRow from './EventCalendarRow'
import Phrase from '../../libs/translationsUtils/phrase'

interface Event {
    id: number,
    type?: string,
    startAt: number,
    title: string,
    destinationUrl: string
}

interface State {
  eventsList: Array<Event>,
  isLoading: boolean
}

interface Props {
  maxResults: number,
  title: string
}

class EventsCalendarWidget extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      eventsList: [],
      isLoading: false
    }
  }

  async componentDidMount () {
    this.setState({ isLoading: true })
    try {
      const res = await axios.get('/widget/eventsCalendar', {
        params: {
          maxResults: this.props.maxResults
        }
      })
      if (res.data) {
        this.setState({ eventsList: res.data, isLoading: false })
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  render (props: Props, state: State) {
    let eventsCount = state.eventsList.length
    let showTwoColumns = (eventsCount === 4 || eventsCount === 2)
    return (
      <div className='event-calendar-container'>
        { props.title && eventsCount > 0 ? <h3 class='widget-title'>{ props.title } </h3> : '' }
        {
          state.isLoading ? '' : (eventsCount > 0 ? (
            <div className={`event-calendar-wrapper ${showTwoColumns ? 'event-calendar-wrapper-two-column' : 'event-calendar-wrapper-three-column'}`}>
              { state.eventsList.map(event => <EventCalendarRow {...event} />)}
            </div>
          ) : ''
          ) }
        {state.isLoading ? '' : (eventsCount > 0 ? (
          <a href='/events' className='btn--cta btn--show-more'> <Phrase p='events.show.more' m='Forum' /> </a>) : '')}
      </div>
    )
  }
}

export default EventsCalendarWidget
